import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="open-select"
export default class extends Controller {
  static targets = ["select"]

  open() {
    this.selectTarget.showPicker()
  }
}
